/**
 * Click-to-play for the "Video" block (blocks/video.liquid + snippets/video.liquid).
 *
 * snippets/video.liquid renders a cover image (.xo-video__poster, z-index 10)
 * on top of the video whenever autoplay is off, and nothing else in the theme
 * hides it on click - so this file does.
 *
 * Every poster/video pair is set up on its own (one .xo-video wrapper each).
 * The block can hold TWO pairs - one for desktop and one for mobile, only one
 * of them visible at a time - so a handler must never be attached "to the
 * first video found in the block": on a phone that is the hidden desktop one,
 * and tapping the visible poster then does nothing.
 *
 * 1. Tapping the poster hides it and plays the video next to it.
 * 2. Tapping a video WITHOUT native controls toggles play/pause. Videos with
 *    controls are left to the browser, which already does it.
 * 3. The separate "video button" block (.xo-video__button) plays the video
 *    that is currently visible, not the first one in the DOM. The theme's own
 *    handler for that button always picks the first video, so this file
 *    intercepts the click before it (capture phase) and does the job itself.
 * 4. A YouTube / Vimeo LINK renders an <iframe> instead of a <video>. Points 1
 *    and 3 used to look for a <video> only, so with a link the cover never went
 *    away and the play button did nothing. An iframe is started by reloading it
 *    with autoplay switched on - the click that triggers this is the user
 *    gesture the browser needs (the same approach "lite" embeds use, and it
 *    works on iOS, where messaging a player that has not started often doesn't).
 */
(function () {
  function isVisible(el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
  }

  function play(video) {
    // iOS only plays inline (instead of forcing fullscreen) with this attribute
    video.setAttribute('playsinline', '');
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  // YouTube / Vimeo embed: the src carries autoplay=0 while a cover is shown.
  function playEmbed(iframe) {
    var src = iframe.getAttribute('src') || '';
    var next = src.replace(/([?&])autoplay=0/, '$1autoplay=1');
    if (next !== src) iframe.setAttribute('src', next);
  }

  function playPair(pair) {
    var video = pair.querySelector('video');
    if (video) return play(video);
    var embed = pair.querySelector('iframe');
    if (embed) playEmbed(embed);
  }

  function hidePoster(pair) {
    var poster = pair.querySelector('.xo-video__poster');
    if (poster) poster.style.display = 'none';
  }

  function setupPair(pair) {
    if (pair.dataset.videoPairInit) return;
    var video = pair.querySelector('video');
    var embed = video ? null : pair.querySelector('iframe');
    if (!video && !embed) return;
    pair.dataset.videoPairInit = 'true';

    var poster = pair.querySelector('.xo-video__poster');
    if (poster) {
      poster.style.cursor = 'pointer';
      poster.addEventListener('click', function () {
        hidePoster(pair);
        playPair(pair);
      });
      if (video) {
        video.addEventListener('play', function () {
          hidePoster(pair);
        });
      }
    }

    // YouTube / Vimeo handle their own click, pause and controls.
    if (!video) return;

    // With native controls on, the browser already toggles play/pause when the
    // video is clicked - adding our own toggle made it pause and instantly
    // resume. Our toggle is only for videos without controls.
    video.addEventListener('click', function () {
      if (video.controls) return;
      if (video.paused || video.ended) {
        play(video);
      } else {
        video.pause();
      }
    });
  }

  function setupHost(host) {
    if (host.dataset.videoHostInit) return;
    host.dataset.videoHostInit = 'true';

    host.querySelectorAll('.xo-video').forEach(setupPair);

    host.addEventListener(
      'click',
      function (event) {
        var button = event.target.closest && event.target.closest('.xo-video__button');
        if (!button || !host.contains(button)) return;
        // Stop the theme's handler (it targets the first video, which may be hidden)
        event.stopImmediatePropagation();
        var pairs = Array.prototype.slice.call(host.querySelectorAll('.xo-video'));
        var pair = pairs.filter(function (p) {
          return isVisible(p) && (p.querySelector('video') || p.querySelector('iframe'));
        })[0];
        if (!pair) return;
        button.style.setProperty('display', 'none');
        button.setAttribute('xo-hidden', 'true');
        hidePoster(pair);
        playPair(pair);
      },
      true
    );
  }

  function scan() {
    document.querySelectorAll('.xo-main-video').forEach(setupHost);
  }

  scan();
  document.addEventListener('shopify:section:load', scan);
})();
